import {omit} from "lodash";
import {
  convertJsonSchemaToShorthandIfPossible
} from "../../../json/schema/convert-json-schema-to-shorthand-if-possible";
import {ProophBoardDescriptionKeys} from "../../descriptions";
import {AnyRule} from "../../rule-definitions";
import {PlayCommandRuntimeInfo} from "./command-definitions";

export const prepareDiffCommand = (command: PlayCommandRuntimeInfo, rules: AnyRule[]): object => {
  return {
    desc: omit(command.desc, ProophBoardDescriptionKeys),
    schema: convertJsonSchemaToShorthandIfPossible(command.schema),
    uiSchema: command.uiSchema,
    factory: command.factory,
    rules
  }
}
